import { NgModule } from '@angular/core';
import { StepperTouchDirective } from '../directives/stepper-touch.directive';

@NgModule({
  declarations: [StepperTouchDirective],
  exports: [StepperTouchDirective],
})
export class StepperTouchModule {}
